import src from "IMAGE";
export default { src, width: 177, height: 209, blurWidth: 0, blurHeight: 0};
